import { render } from "./modalDetail.vue?vue&type=template&id=687003d8&scoped=true"
import script from "./modalDetail.vue?vue&type=script&lang=js"
export * from "./modalDetail.vue?vue&type=script&lang=js"

import "./modalDetail.vue?vue&type=style&index=0&id=687003d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687003d8"]])

export default __exports__